import React, { useState, useEffect } from "react"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import logo from "../../assets/images/logo.png"
import { CardBody, Table, Card } from "reactstrap"
import { URLS } from "../../Url"
import axios from "axios"

function Subscriptions() {
  const GetAuth = localStorage.getItem("authUser")
  const TokenJson = GetAuth ? JSON.parse(GetAuth) : null
  const TokenData = TokenJson?.token

  const [subscriber, setSubscriber] = useState([])
  const [subscription, setSubscription] = useState(null)
  const [subscriptions, setSubscriptions] = useState(null)
  const [Cancelled, setCancelled] = useState([])
  const [showCancelModal, setShowCancelModal] = useState(false)
  const [cancelReason, setCancelReason] = useState("")
  const [isCancelling, setIsCancelling] = useState(false)

  const [loading, setLoading] = useState({
    subscriber: false,
    currentPlan: false,
  })
  const [error, setError] = useState({
    subscriber: null,
    currentPlan: null,
  })

  useEffect(() => {
    getSubscriber()
    getCurrentplan()
  }, [])

  const getSubscriber = async () => {
    try {
      setLoading(prev => ({ ...prev, subscriber: true }))
      setError(prev => ({ ...prev, subscriber: null }))

      const token = TokenData
      if (!token) {
        throw new Error("Authentication token not found")
      }

      const response = await axios.post(
        URLS.GetSubscription,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      )

      setSubscriber(response.data.subscriptions || [])
    } catch (error) {
      console.error("Error fetching Subscriber:", error)
      const errorMessage =
        error.response?.data?.message || "Failed to fetch subscription plans"
      setError(prev => ({
        ...prev,
        subscriber: errorMessage,
      }))
      toast.error(errorMessage)
    } finally {
      setLoading(prev => ({ ...prev, subscriber: false }))
    }
  }

  const getCurrentplan = async () => {
    try {
      setLoading(prev => ({ ...prev, currentPlan: true }))
      setError(prev => ({ ...prev, currentPlan: null }))

      const token = TokenData
      if (!token) {
        throw new Error("Authentication token not found")
      }

      const response = await axios.post(
        URLS.GetCurrentSubscription,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      )
      if (response.data.subscribers && response.data.subscribers.length > 0) {
        setSubscription(response.data.subscribers[0])
        setSubscriptions(response.data)
        setCancelled(response.data.cancelledSubscribers)
      } else {
        setSubscription(null)
        setSubscriptions(null)
        setCancelled([])
      }
    } catch (error) {
      console.error("Error fetching current subscription:", error)
      const errorMessage =
        error.response?.data?.message || "Failed to fetch current subscription"
      setError(prev => ({
        ...prev,
        currentPlan: errorMessage,
      }))
      toast.error(errorMessage)
    } finally {
      setLoading(prev => ({ ...prev, currentPlan: false }))
    }
  }

  const handleCancelSubscription = async () => {
    if (!cancelReason.trim()) {
      toast.error("Please provide a cancellation reason")
      return
    }

    if (!subscription?._id) {
      toast.error("No subscription found to cancel")
      return
    }

    try {
      setIsCancelling(true)
      const token = TokenData
      const response = await axios.put(
        `${URLS.CancelSubscription}${subscription._id}`,
        { cancelReason: cancelReason.trim() },
        { headers: { Authorization: `Bearer ${token}` } }
      )

      if (response.status === 200) {
        toast.success("Subscription cancelled successfully")
        setShowCancelModal(false)
        setCancelReason("")
        getCurrentplan()
      }
    } catch (error) {
      console.error("Error cancelling subscription:", error)
      const errorMessage =
        error.response?.data?.message || "Failed to cancel subscription"
      toast.error(errorMessage)
    } finally {
      setIsCancelling(false)
    }
  }

  const authData = JSON.parse(localStorage.getItem("authUser") || "{}")
  const vendorDetails = authData?.vendor || {}

  const handlePayment = data => {
    if (!TokenData) {
      toast.error("Authentication token missing")
      return
    }

    if (!data?._id || !data?.price) {
      toast.error("Invalid subscription plan data")
      return
    }

    const totals = parseInt(data.price) * 100
    const options = {
      key: "rzp_test_HJG5Rtuy8Xh2NB",
      amount: totals,
      currency: "INR",
      name: "Bizzmate",
      description: `Subscription for ${data.name} plan`,
      image: logo,
      handler: async function (response) {
        try {
          const paymentResponse = await axios.post(
            URLS.BuySubscription,
            {
              planId: data._id,
              transactionStatus: "completed",
              transactionId: response.razorpay_payment_id,
              amount: data.price,
            },
            { headers: { Authorization: `Bearer ${TokenData}` } }
          )

          if (paymentResponse.status === 200) {
            toast.success(paymentResponse.data.message)
            getCurrentplan()
          }
        } catch (error) {
          console.error("Payment processing error:", error)
          const errorMessage =
            error.response?.data?.message || "Failed to process payment"
          toast.error(errorMessage)
        }
      },
      prefill: {
        name: `${vendorDetails.firstName || ""} ${
          vendorDetails.lastName || ""
        }`.trim(),
        email: vendorDetails.email || "",
        contact: vendorDetails.sellerMobile || "",
      },
      theme: {
        color: "#00578E",
      },
      modal: {
        ondismiss: function () {
          toast.info("Payment window closed")
        },
      },
    }

    const rzp1 = new window.Razorpay(options)
    rzp1.open()
  }

  const formatDate = dateString => {
    if (!dateString) return "N/A"
    try {
      const date = new Date(dateString)
      if (isNaN(date.getTime())) return "Invalid date"

      const options = { year: "numeric", month: "long", day: "numeric" }
      return date.toLocaleDateString(undefined, options)
    } catch (error) {
      console.error("Error formatting date:", error)
      return "Invalid date"
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title="Bizzmate Supplier"
            breadcrumbItem="Subscription"
          />

          {/* Cancel Subscription Modal */}
          {showCancelModal && (
            <div
              className="modal fade show d-block"
              style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
              tabIndex="-1"
              role="dialog"
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Cancel Subscription</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => {
                        setShowCancelModal(false)
                        setCancelReason("")
                      }}
                      disabled={isCancelling}
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">
                    <p className="text-muted mb-3">
                      Please let us know why you're cancelling your
                      subscription. This helps us improve our service.
                    </p>
                    <div className="mb-3">
                      <label htmlFor="cancelReason" className="form-label">
                        Cancellation Reason{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <textarea
                        id="cancelReason"
                        className="form-control"
                        rows="4"
                        placeholder="Enter your reason for cancellation..."
                        value={cancelReason}
                        onChange={e => setCancelReason(e.target.value)}
                        disabled={isCancelling}
                      />
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => {
                        setShowCancelModal(false)
                        setCancelReason("")
                      }}
                      disabled={isCancelling}
                    >
                      Close
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={handleCancelSubscription}
                      disabled={isCancelling || !cancelReason.trim()}
                    >
                      {isCancelling ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" />
                          Cancelling...
                        </>
                      ) : (
                        "Confirm Cancellation"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {loading.currentPlan ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-2">Loading your subscription details...</p>
            </div>
          ) : error.currentPlan ? (
            <div className="alert alert-danger text-center">
              {error.currentPlan}
              <button
                className="btn btn-link p-0 ms-2"
                onClick={getCurrentplan}
              >
                Retry
              </button>
            </div>
          ) : subscription ? (
            <>
              <div className="row justify-content-center">
                <div className="col-lg-10">
                  <div className="card subscription-card">
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-center mb-4">
                        <div>
                          <h3 className="card-title mb-1">
                            My Subscription Plan
                          </h3>
                          <p className="text-muted mb-0">
                            View your current subscription details
                          </p>
                        </div>
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() => setSubscription(null)}
                        >
                          View Available Plans
                        </button>
                      </div>

                      <div className="subscription-details">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="mb-2">
                              <h5 className="section-title mb-3">
                                Plan Details
                              </h5>
                              <div className="p-3 bg-light rounded-3">
                                <div className="d-flex justify-content-between mb-2">
                                  <span className="text-muted">Plan Name:</span>
                                  <span className="fw-medium">
                                    {subscription.planName || "N/A"}
                                  </span>
                                </div>
                                <div className="d-flex justify-content-between mb-2">
                                  <span className="text-muted">Duration:</span>
                                  <span className="fw-medium">
                                    {subscription.duration || "N/A"}
                                  </span>
                                </div>
                                <div className="d-flex justify-content-between mb-2">
                                  <span className="text-muted">Amount:</span>
                                  <span className="fw-medium">
                                    ₹{subscription.amount || "0"}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-2">
                              <h5 className="section-title mb-3">
                                Payment Details
                              </h5>
                              <div className="p-3 bg-light rounded-3">
                                <div className="d-flex justify-content-between mb-2">
                                  <span className="text-muted">
                                    Payment Status:
                                  </span>
                                  <b
                                    className={`text-${
                                      subscription.paymentStatus === "completed"
                                        ? "success"
                                        : "warning"
                                    }`}
                                  >
                                    {subscription.paymentStatus || "pending"}
                                  </b>
                                </div>
                                <div className="d-flex justify-content-between mb-2">
                                  <span className="text-muted">
                                    Transaction ID:
                                  </span>
                                  <span
                                    className="fw-medium text-truncate"
                                    style={{ maxWidth: "150px" }}
                                    title={subscription.transactionId || "N/A"}
                                  >
                                    {subscription.transactionId || "N/A"}
                                  </span>
                                </div>
                                <div className="d-flex justify-content-between mb-2">
                                  <span className="text-muted">
                                    Payment Date:
                                  </span>
                                  <span className="fw-medium">
                                    {formatDate(subscription.logCreatedDate)}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row mt-2">
                          <div className="col-12">
                            <div className="mb-2">
                              <h5 className="section-title mb-2">
                                Subscription Status
                              </h5>
                              <div className="p-3 bg-light rounded-3">
                                <div className="row align-items-center">
                                  <div className="col-md-3 mb-3 mb-md-0">
                                    <span className="d-block text-muted mb-1">
                                      Status:
                                    </span>
                                    <b
                                      className={`text-${
                                        subscription.status === "active"
                                          ? "success"
                                          : "danger"
                                      } fs-6`}
                                    >
                                      {subscription.status || "inactive"}
                                    </b>
                                  </div>
                                  <div className="col-md-3 mb-3 mb-md-0">
                                    <span className="d-block text-muted mb-1">
                                      Plan Duration:
                                    </span>
                                    <span className="fw-medium">
                                      {subscriptions?.duration || "N/A"}
                                    </span>
                                  </div>
                                  <div className="col-md-3 mb-3 mb-md-0">
                                    <span className="d-block text-muted mb-1">
                                      Days Remaining:
                                    </span>
                                    <span className="fw-medium">
                                      {subscriptions?.remainingDaysLeft || 0}{" "}
                                      days
                                    </span>
                                  </div>
                                  <div className="col-md-3">
                                    <span className="d-block text-muted mb-1">
                                      Actions:
                                    </span>
                                    <button
                                      className="btn btn-primary btn-sm"
                                      onClick={() => setShowCancelModal(true)}
                                      disabled={
                                        subscription.status !== "active"
                                      }
                                    >
                                      Cancel Plan
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <>
                {Cancelled.length > 0 ? (
                  <Card>
                    <CardBody>
                      <h5>Cancelled Subscription List</h5>
                      <div className="table-rep-plugin mt-4 table-responsive">
                        <Table hover className="table table-bordered mb-4">
                          <thead>
                            <tr className="text-center">
                              <th>Sl No</th>
                              <th>Plan Name</th>
                              <th>Plan Duration</th>
                              <th>Amount</th>
                              <th>Transaction Status</th>
                              <th>Payment Status</th>
                              <th>Refund Status</th>
                              <th>Cancelled Date</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Cancelled.map((data, key) => (
                              <tr key={key} >
                                <td>{key + 1}</td>
                                <td>
                                  <div className="d-flex ">
                                    {data.planImage && (
                                      <img
                                        src={URLS.Base+ data.planImage}
                                        alt={data.planName}
                                        className="rounded me-2"
                                        style={{
                                          width: "30px",
                                          height: "30px",
                                          objectFit: "cover",
                                        }}
                                      />
                                    )}
                                    <div>
                                      <div className="fw-semibold">
                                        {data.planName}
                                      </div>
                                      <small className="text-muted">
                                        {data.planDescription}
                                      </small>
                                    </div>
                                  </div>
                                </td>
                                <td>{data.planDuration}</td>
                                <td>
                                  <div className="d-flex flex-column">
                                    <span className="fw-semibold">
                                      ₹{data.amount}
                                    </span>
                                    {data.paymentAmount !== data.amount && (
                                      <small className="text-muted">
                                        Paid: ₹{data.paymentAmount}
                                      </small>
                                    )}
                                  </div>
                                </td>
                                <td>
                                  <span
                                    className={`text-${
                                      data.transactionStatus === "completed"
                                        ? "success"
                                        : "warning"
                                    }`}
                                  >
                                    {data.transactionStatus}
                                  </span>
                                </td>
                                <td>
                                  <span
                                    className={`text-${
                                      data.paymentStatus === "completed"
                                        ? "success"
                                        : "warning"
                                    }`}
                                  >
                                    {data.paymentStatus}
                                  </span>
                                </td>
                                <td>
                                  <span
                                    className={`text-${
                                      data.amount > 0 &&
                                      data.paymentStatus === "completed"
                                        ? "info"
                                        : "secondary"
                                    }`}
                                  >
                                    {data.amount > 0 &&
                                    data.paymentStatus === "completed"
                                      ? "Refund Pending"
                                      : "No Refund"}
                                  </span>
                                </td>
                                <td>
                                  <div className="d-flex flex-column">
                                    <span>{data.canceledDate}</span>
                                    <small className="text-muted">
                                      {data.cancellTime}
                                    </small>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </CardBody>
                  </Card>
                ) : (
                  ""
                )}{" "}
              </>
            </>
          ) : (
            <>
              <div className="row justify-content-center mt-2">
                <div className="col-lg-8 text-center">
                  <h2 className="mb-2">Choose Your Pricing Plan</h2>
                  <p className="text-muted mb-2">
                    Select the plan that best fits your business needs
                  </p>
                </div>
              </div>
              {loading.subscriber ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="mt-2">Loading available plans...</p>
                </div>
              ) : error.subscriber ? (
                <div className="alert alert-danger text-center">
                  {error.subscriber}
                  <button
                    className="btn btn-link p-0 ms-2"
                    onClick={getSubscriber}
                  >
                    Retry
                  </button>
                </div>
              ) : (
                <div className="row justify-content-center mb-5">
                  {subscriber.map((data, i) => (
                    <div className="col-md-3 col-xl-3 mb-4" key={data._id || i}>
                      <div
                        className={`plan-card card h-100 ${
                          i % 2 === 0 ? "border-primary" : "border-success"
                        }`}
                      >
                        <div className="card-body d-flex flex-column">
                         <div className="text-center ">
                           {data.image && (
                              <div className="flex-shrink-0 ms-3">
                                <img
                                  src={`${URLS.Base}${data.image}`}
                                  alt={data.name}
                                  className="img-fluid plan-image"
                                  style={{
                                    width: "60px",
                                    height: "60px",
                                    objectFit: "contain",
                                  }}
                                  onError={e => {
                                    e.target.style.display = "none"
                                  }}
                                />
                              </div>
                            )}</div>
                          <div className="text-center mb-2">
                            <div className="flex-grow-1">
                              <h4 className="plan-name">{data.name}</h4>
                              <p className="text-muted plan-description">
                                {data.description}
                              </p>
                            </div>
                           
                          </div>

                          <div className="text-center py-3">
                            <h2 className="plan-price">
                              <sup>
                                <small>₹</small>
                              </sup>
                              {data.price}
                              <span className="font-size-16 text-muted">
                                {" "}
                                / {data.duration}
                              </span>
                            </h2>
                          </div>

                          <div className="plan-features mt-3 mb-4 flex-grow-1">
                            {data?.benefits?.map((datas, k) => (
                              <div
                                className="d-flex align-items-start mb-2"
                                key={datas?._id || k}
                              >
                                <i className="bx bx-check text-success mt-1 me-2" />
                                <span>{datas?.benefits}</span>
                              </div>
                            ))}
                          </div>

                          <div className="text-center mt-auto">
                            <button
                              className="btn btn-primary w-100 btn-sm"
                              onClick={() => handlePayment(data)}
                              disabled={!subscriber || subscriber.length === 0}
                            >
                              Subscribe Now
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </>
          )}

          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </div>
      </div>
    </React.Fragment>
  )
}

export default Subscriptions
